module.exports = __webpack_public_path__ + "img/message-medical.068e069a.svg";